import React from 'react'

function Preloader({load}) {
  return (
    <div className={load ? 'preloader' :  'preloader-none'}>
    </div>
  )
}

export default Preloader
